export const contactsData = {
    email: 'jamesbn1215@gmail.com',
    phone: '+17828098550',
    address: '120 S 8th St, Columbia, MO 65201',

    sheetAPI: ''
}